import {ChangeDetectorRef, ModuleWithProviders, NgModule, Provider} from "@angular/core";
import {NbButtonModule, NbCardModule, NbCheckboxModule, NbDatepickerModule, NbIconModule, NbInputModule, NbPopoverModule, NbRadioModule, NbToastrModule} from "@nebular/theme";
import {DateAmountSincePipe} from "./pipes/date-amount-since.pipe";
import {SortByPipe} from "./pipes/sort-by.pipe";
import {StickyOnScrollPanelComponent} from "./components/sticky-on-scroll-panel/sticky-on-scroll-panel.component";
import {AsyncPipe, CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {WaitingSpinnerComponent} from "./components/waiting-spinner/waiting-spinner.component";
import {AngularSvgIconModule} from "angular-svg-icon";
import {ProcessTypeDisplayPipe} from "./pipes/process-type-display.pipe";
import {StandardNamePipe} from "./pipes/standard-name.pipe";
import {CopyButtonComponent} from "./copy-button/copy-button.component";
import {TextAreaComponent} from "./components/text-area-component/text-area.component";
import {BinaryQuestionComponent} from "./components/binary-question/binary-question.component";
import {BinaryQuestionWithCommentComponent} from "./components/binary-question-with-comment/binary-question-with-comment.component";
import {CopyClipboardDirective} from "./directives/copy-clipboard-directive.service";
import {ChecklistQuestionComponent} from "./components/checklist-question/checklist-question.component";
import {ChecklistAccordionComponent} from "./components/checklist-accordion/checklist-accordion.component";
import {ReviewDeclineDialogComponent} from "./components/review-decline-dialog/review-decline-dialog.component";
import {RiskNamePipe} from "./pipes/risk-name.pipe";
import {ReviewChecklistDocumentsComponent} from "./components/review-checklist-documents/review-checklist-documents.component";
import {ReviewChecklistDocumentComponent} from "./components/review-checklist-documents/review-checklist-document/review-checklist-document.component";
import {ReviewChecklistResolver} from "./components/review-checklist-documents/review-checklist-document/review-checklist-resolver.service";
import {ReviewerDocumentOrderResolver} from "./components/review-checklist-documents/review-checklist-document/reviewer-document-order-resolver.service";
import {ToGroupNamePipe} from "./pipes/question-group.pipe";
import {QuestionTranslatorFactoryService} from "./services/question-translator-factory.service";
import {SalesForceCardComponent} from "./components/sales-force-card/sales-force-card.component";
import {SalesForceCardFormService} from "./components/sales-force-card/sales-force-card-form.service";
import {HeaderVisibilityService} from "./services/header-visibility.service";
import {HideHeaderOnInputFocusDirective} from "./directives/hide-header-on-input-focus.directive";
import {AutoFocusDirective} from "./directives/auto-focus.directive";
import {PricePipe} from "./pipes/price.pipe";
import {ClickedOutside} from "./directives/clicked-outside.directive";
import {StatusLabelComponent} from "./components/status-label/status-label.component";
import {AccountExistsValidatorFactory} from "./validation/account-exists-validator.service";
import {AesEncryptorService} from "./services/aes-encryptor.service";
import {InternalDocumentsComponent} from "./components/internal-documents/internal-documents.component";
import {InternalDocumentsService} from "./components/internal-documents/internal-documents.service";
import {InternalDocumentEntryComponent} from "./components/internal-documents/internal-document-entry/internal-document-entry.component";
import {ScrollToFailedValidationDirective} from "./directives/scroll-to-failed-validation/scroll-to-failed-validation.directive";
import {SameUrlNavigationDetector} from "./services/same-url-navigation-detector.service";
import {TranslateModule} from "@ngx-translate/core";
import {ClientResourcesFetchService} from "./services/client-resources-fetch.service";
import {EffortNamePipe} from "./pipes/effort-name.pipe";
import {LocalizedDatePipe} from './pipes/localized-date.pipe';
import {PasswordValidatorFactory} from "./validation/password-validator/password-validator.factory";
import {PasswordConditionsComponent} from "./components/password-conditions/password-conditions.component";
import {CookiesBannerComponent} from './cookies-banner/cookies-banner.component';
import {RouterModule} from "@angular/router";
import {BannerLinkComponent} from './cookies-banner/banner-link/banner-link.component';
import {NegationPipe} from "./pipes/negation.pipe";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {NoConnectionHandler} from "./services/no-connection.handler";
import {EndpointsProvider} from "./endpoints/endpoint-provider.service";
import {AppVersionComponent} from "./components/app-version/app-version.component";
import {VersionInfoPipe} from "./components/app-version/version-info.pipe";
import {DekraLogoComponent} from './dekra-logo/dekra-logo.component';
import {OneLineDisplayDirective} from "./directives/one-line-display.directive";
import {NotificationService} from "./services/notification.service";
import {PasswordStrengthBarComponent} from "./components/password-strength-bar/password-strength-bar.component";

@NgModule({
	imports: [
		NbToastrModule,
		NbButtonModule,
		NbCardModule,
		NbIconModule,
		NbPopoverModule,
		NbDatepickerModule,
		FormsModule,
		NbRadioModule,
		NbInputModule,
		ReactiveFormsModule,
		CommonModule,
		AngularSvgIconModule,
		NbCheckboxModule,
		TranslateModule,
		RouterModule,
		PasswordStrengthBarComponent,
	],
	exports: [
		DateAmountSincePipe,
		SortByPipe,
		PricePipe,
		StickyOnScrollPanelComponent,
		ChecklistQuestionComponent,
		ChecklistAccordionComponent,
		WaitingSpinnerComponent,
		ProcessTypeDisplayPipe,
		StandardNamePipe,
		CopyButtonComponent,
		TextAreaComponent,
		BinaryQuestionComponent,
		BinaryQuestionWithCommentComponent,
		CopyClipboardDirective,
		ReviewDeclineDialogComponent,
		ReviewChecklistDocumentsComponent,
		ReviewChecklistDocumentComponent,
		RiskNamePipe,
		EffortNamePipe,
		ToGroupNamePipe,
		SalesForceCardComponent,
		HideHeaderOnInputFocusDirective,
		AutoFocusDirective,
		ClickedOutside,
		StatusLabelComponent,
		InternalDocumentsComponent,
		InternalDocumentEntryComponent,
		ScrollToFailedValidationDirective,
		LocalizedDatePipe,
		PasswordConditionsComponent,
		CookiesBannerComponent,
		BannerLinkComponent,
		NegationPipe,
		AppVersionComponent,
		DekraLogoComponent,
		OneLineDisplayDirective
	],
	declarations: [
		DateAmountSincePipe,
		SortByPipe,
		PricePipe,
		StickyOnScrollPanelComponent,
		ChecklistQuestionComponent,
		ChecklistAccordionComponent,
		WaitingSpinnerComponent,
		ProcessTypeDisplayPipe,
		StandardNamePipe,
		CopyButtonComponent,
		TextAreaComponent,
		BinaryQuestionComponent,
		BinaryQuestionWithCommentComponent,
		CopyClipboardDirective,
		ReviewDeclineDialogComponent,
		ReviewChecklistDocumentsComponent,
		ReviewChecklistDocumentComponent,
		RiskNamePipe,
		EffortNamePipe,
		ToGroupNamePipe,
		SalesForceCardComponent,
		HideHeaderOnInputFocusDirective,
		AutoFocusDirective,
		ClickedOutside,
		StatusLabelComponent,
		InternalDocumentsComponent,
		InternalDocumentEntryComponent,
		ScrollToFailedValidationDirective,
		LocalizedDatePipe,
		PasswordConditionsComponent,
		CookiesBannerComponent,
		BannerLinkComponent,
		NegationPipe,
		AppVersionComponent,
		VersionInfoPipe,
		DekraLogoComponent,
		OneLineDisplayDirective
	],
	providers: UmbrellaCommonModule.PROVIDERS
})
export class UmbrellaCommonModule {

	static readonly PROVIDERS: Provider[] = [
		ReviewChecklistResolver,
		ReviewerDocumentOrderResolver,
		QuestionTranslatorFactoryService,
		SalesForceCardFormService,
		HeaderVisibilityService,
		AccountExistsValidatorFactory,
		AesEncryptorService,
		InternalDocumentsService,
		SameUrlNavigationDetector,
		ClientResourcesFetchService,
		PasswordValidatorFactory,
		AsyncPipe,
		ChangeDetectorRef as Provider,
		LocalizedDatePipe,
		EndpointsProvider,
		NotificationService
	];

	static forRoot(): ModuleWithProviders<UmbrellaCommonModule> {
		return {
			ngModule: UmbrellaCommonModule,
			providers: [
				{provide: HTTP_INTERCEPTORS, useClass: NoConnectionHandler, multi: true},
				DateAmountSincePipe,
				SortByPipe,
				PricePipe,
				StandardNamePipe,
				AccountExistsValidatorFactory,
				AesEncryptorService,
				SameUrlNavigationDetector
			]
		};
	}

}
